module.exports = {
          srcSet: __webpack_public_path__ + "165f4be5.jpg"+" 700w"+","+__webpack_public_path__ + "e10adbc7.jpg"+" 1400w"+","+__webpack_public_path__ + "2f9a2d87.jpg"+" 2048w",
          images:[ {path: __webpack_public_path__ + "165f4be5.jpg",width: 700,height: 467},{path: __webpack_public_path__ + "e10adbc7.jpg",width: 1400,height: 933},{path: __webpack_public_path__ + "2f9a2d87.jpg",width: 2048,height: 1365}],
          src: __webpack_public_path__ + "165f4be5.jpg",
          toString:function(){return __webpack_public_path__ + "165f4be5.jpg"},
          
          width: 700,
          height: 467
        }